export const aboutContent = {
  brandIntro: {
    title: '关于喑网91',
    description: '喑网91成立于2018年，是一家专注于综合性网络服务平台的科技创新企业。我们致力于通过技术驱动，为广大用户提供安全、高效、智能的在线服务体验。',
    paragraphs: [
      '喑网91自成立以来，始终秉持"用户至上、技术驱动"的核心价值观，不断深耕网络服务领域。经过多年的发展，喑网91已经成长为覆盖全国、服务数百万用户的成熟平台，赢得了广泛的市场认可与用户信赖。',
      '我们的团队由来自互联网、大数据、人工智能等多个领域的资深专家组成，拥有丰富的行业经验与深厚的技术积累。团队成员共同致力于将喑网91打造成为行业领先的综合网络服务平台。',
      '喑网91高度重视技术创新与产品体验，持续投入大量资源进行研发与优化。我们相信，只有不断进步的喑网91，才能持续为用户创造价值。',
    ],
    imageSeq: 'about-brand-bg',
    imageQuery: 'Warm%20amber%20and%20cream%20abstract%20background%20with%20soft%20geometric%20patterns%2C%20professional%20corporate%20atmosphere%2C%20clean%20minimal%20design%2C%20elegant%20flowing%20shapes%2C%20subtle%20gradient%20texture%2C%20peaceful%20and%20trustworthy%20feeling',
  },
  milestones: [
    { year: '2018', event: '喑网91正式创立，核心团队组建完成' },
    { year: '2019', event: '完成基础平台搭建，正式上线运营' },
    { year: '2020', event: '用户突破百万，推出智能匹配功能' },
    { year: '2021', event: '数据分析面板上线，完成A轮融资' },
    { year: '2022', event: '用户突破三百万，推出个性化定制功能' },
    { year: '2023', event: '安全防护体系全面升级，获行业安全认证' },
    { year: '2024', event: '完成B轮融资，全面拓展全国市场' },
    { year: '2025', event: '用户突破五百万，平台功能矩阵全面覆盖' },
    { year: '2026', event: '发布全新版本，智能匹配算法重大升级' },
  ],
  values: [
    { title: '用户至上', description: '始终将用户需求放在首位，以优质体验赢得信赖', icon: 'ri-heart-line' },
    { title: '技术驱动', description: '持续技术创新，以领先技术赋能产品与服务', icon: 'ri-cpu-line' },
    { title: '安全可靠', description: '全方位保障用户安全，打造值得信赖的网络平台', icon: 'ri-shield-check-line' },
    { title: '持续创新', description: '不断突破自我，追求更卓越的产品与更优质的服务', icon: 'ri-lightbulb-line' },
  ],
  reputation: {
    title: '用户口碑',
    description: '喑网91以优质的服务与可靠的产品赢得广泛好评',
    reviews: [
      { name: '赵先生', role: '个人用户 · 使用3年', content: '喑网91是我用过最好的网络服务平台，功能齐全，操作流畅，客服响应非常及时。强烈推荐给每一位需要的朋友。', rating: 5, platform: '官方社区' },
      { name: '孙女士', role: '企业用户 · 使用2年', content: '作为企业用户，喑网91帮助我们大幅提升了运营效率。数据分析功能特别实用，团队协作体验也很出色。', rating: 5, platform: '企业评价平台' },
      { name: '周同学', role: '学生用户 · 使用1年', content: '喑网91的使用指南非常友好，作为新用户很快就上手了。平台的稳定性和安全性让我很放心。', rating: 5, platform: '应用商店' },
      { name: '吴经理', role: '企业管理者 · 使用2年', content: '喑网91是我们团队不可或缺的工具。从数据分析到智能匹配，每一项功能都设计得很用心。', rating: 4, platform: '行业论坛' },
      { name: '郑女士', role: '自由职业者 · 使用1.5年', content: '喑网91帮我节省了大量时间，智能匹配功能总能推荐我需要的内容，用户体验做得非常出色。', rating: 5, platform: '社交平台' },
      { name: '冯先生', role: '技术从业者 · 使用3年', content: '从技术角度来看，喑网91的架构设计非常优秀。系统的稳定性和响应速度一直保持在高水平。', rating: 5, platform: '技术社区' },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如有任何问题或建议，欢迎通过以下方式与喑网91团队取得联系',
    email: 'contact@echo64.cn',
    phone: '400-XXX-9100',
    wechat: 'yinwang91_official',
    workingHours: '周一至周日 9:00 - 21:00',
    address: '中国 · 喑网91总部',
  },
};